import {
    GetLevelsList,
    GetPoolsList,
    GetTeachersList,
    GetUnitsList,
    GetPlansList,
    GetCustomerSuccessList,
    GetPedagogicTypeList,
    GetGoalsList,
    GetContentsList,
    GetStaffList,
    GetClientsList,
    GetPartnersList,
    GetLanguageList,
    GetStudentList,
    GetUnitsListSimple,
} from '@src/services/form'

import { GetTeamList } from '@src/services/team'

import { getSavedState } from '@src/utils/localStorage'

export const state = {
    levelsList: [],
    poolsList: [],
    teachersList: [],
    unitsList: [],
    plansList: [],
    customersSuccessList: [],
    pedagogicTypeList: [],
    goalsList: [],
    contentsList: [],
    staffList: [],
    clientsList: [],
    buyersList: [],
    partnerList: [],
    languageList: [],
    studentsList: [],
}

export const getters = {}

export const mutations = {
    GET_LEVELS(state, newList) {
        state.levelsList = newList
    },
    GET_POOLS(state, newList) {
        state.poolsList = newList
    },
    GET_TEACHERS(state, newList) {
        state.teachersList = newList
    },
    GET_UNITS(state, newList) {
        state.unitsList = newList
    },
    GET_PLANS(state, newList) {
        state.plansList = newList
    },
    GET_CUSTOMERS_SUCCESS(state, newList) {
        state.customersSuccessList = newList
    },
    GET_PEDAGOGIC_TYPE(state, newList) {
        state.pedagogicTypeList = newList
    },
    GET_GOALS(state, newList) {
        state.goalsList = newList
    },
    GET_CONTENTS(state, newList) {
        state.contentsList = newList
    },
    GET_STAFF(state, newList) {
        state.staffList = newList
    },
    GET_CLIENTS(state, newList) {
        state.clientsList = newList
    },
    GET_BUYERS(state, newList) {
        state.buyersList = newList
    },
    SET_PARTNER_LIST(state, newList) {
        state.partnerList = newList
    },
    SET_LANNGUAGE_LIST(state, newList) {
        state.languageList = newList
    },
    SET_STUDENT_LIST(state, newList) {
        state.studentsList = newList
    },
}

export const actions = {
    async fetchLevelsList({ commit }, parameters = {}) {
        const resp = await GetLevelsList(parameters)
        if (resp.status === 200) {
            commit('GET_LEVELS', resp.data)
            return true
        }
        return false
    },

    async fetchPoolsList({ commit }, parameters = {}) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetPoolsList({ locationPublicId, parameters })
        if (resp.status === 200) {
            commit('GET_POOLS', resp.data)
            return true
        }
        return false
    },

    async fetchTeachersList({ commit }, parameters = {}) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetTeachersList({ locationPublicId, parameters })
        if (resp.status === 200) {
            commit('GET_TEACHERS', resp.data)
            return true
        }
        return false
    },

    async fetchUnitsList({ commit }, parameters = {}) {
        const resp = await GetUnitsList(parameters)
        if (resp.status === 200) {
            commit('GET_UNITS', resp.data)
            return true
        }
        return false
    },

    async fetchUnitsListSimple({ commit }, parameters = {}) {
        const resp = await GetUnitsListSimple(parameters)
        if (resp.status === 200) {
            commit('GET_UNITS', resp.data)
            return true
        }
        return false
    },

    async fetchPlansList({ commit }, parameters = {}) {
        const resp = await GetPlansList(parameters)
        if (resp.status === 200) {
            commit('GET_PLANS', resp.data)
            return true
        }
        return false
    },

    async fetchCustomersSuccessList({ commit }, parameters = {}) {
        const resp = await GetCustomerSuccessList(parameters)
        if (resp.status === 200) {
            commit('GET_CUSTOMERS_SUCCESS', resp.data)
            return true
        }
        return false
    },

    async fetchPedagogicTypesList({ commit }, parameters = {}) {
        const resp = await GetPedagogicTypeList(parameters)
        if (resp.status === 200) {
            commit('GET_PEDAGOGIC_TYPE', resp.data)
            return true
        }
        return false
    },
    async fetchGoalsList({ commit }, parameters = {}) {
        const resp = await GetGoalsList(parameters)
        if (resp.status === 200) {
            commit('GET_GOALS', resp.data)
            return true
        }
        return false
    },
    async fetchContentsList({ commit }, parameters = {}) {
        const resp = await GetContentsList(parameters)
        if (resp.status === 200) {
            commit('GET_CONTENTS', resp.data)
            return true
        }
        return false
    },
    async fetchStaffList({ commit }, parameters = {}) {
        const resp = await GetStaffList(parameters)
        if (resp.status === 200) {
            commit('GET_STAFF', resp.data)
            return true
        }
        return false
    },
    async fetchClientsList({ commit }, parameters = {}) {
        const resp = await GetClientsList(parameters)

        if (resp.status === 200) {
            commit('GET_CLIENTS', resp.data)
            return true
        }
        return false
    },
    async fetchBuyersList({ commit }, parameters = {}) {
        const locationPublicId = parameters.locationPublicId
            ? parameters.locationPublicId
            : getSavedState('auth.selectedLocation').publicId
        const resp = await GetTeamList(locationPublicId, parameters)

        if (resp.status === 200) {
            commit('GET_BUYERS', resp.data)
            return true
        }
        return false
    },
    async fetchPartnerList({ commit }, parameters = {}) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId

        const resp = await GetPartnersList(locationPublicId, parameters)

        if (resp.status === 200) {
            commit('SET_PARTNER_LIST', resp.data)
            return true
        }
        return false
    },
    async fetchLanguageList({ commit }) {
        const resp = await GetLanguageList()
        if (resp.status === 200) {
            commit('SET_LANNGUAGE_LIST', resp.data.data)
            return resp
        }
    },
    async fetchStudentsList({ commit }, parameters = {}) {
        const locationPublicId = getSavedState('auth.selectedLocation').publicId
        const resp = await GetStudentList(locationPublicId, parameters)
        if (resp.status === 200) {
            commit('SET_STUDENT_LIST', resp.data.data.list.items)
        }
    },
}
